import { useNavigate } from 'react-router';
import { Monitor } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { EmptyState } from '@/components/shared/EmptyState';

/**
 * Timeline, Workload and Sprint planning are desktop-only at ≥1024px (§5-F11,
 * §F22). Below that the view is replaced by a clear message and a one-tap route
 * to List, rather than a squeezed grid nobody can use.
 */
export function DesktopOnly({
  title,
  listHref,
  children,
}: {
  title: string;
  listHref: string;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();
  return (
    <>
      <div className="lg:hidden">
        <div className="p-4">
          <EmptyState
            icon={<Monitor className="size-6" />}
            title={`${title} needs a wider screen`}
            description={`${title} is a dense grid that only works at 1024px and above. On this screen, List shows the same tasks.`}
            action={
              <Button variant="primary" onClick={() => navigate(listHref)}>
                Open List instead
              </Button>
            }
          />
        </div>
      </div>
      <div className="hidden lg:block">{children}</div>
    </>
  );
}
